import { storeToRefs } from 'pinia'

import { SfLog } from '@app/adapters/logger'
import api from '@app/application/workflows/screens/workflow-review/api'
import { setQueryParam } from '@app/utils/url-helpers'

import { useWorfklowUI } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-ui'

export const useComparisonModeToggle = (
  redirect: boolean
): {
  turnOnCompareMode: ({
    ledgerId,
    workflowId,
  }: {
    ledgerId: number
    workflowId: number
  }) => Promise<void>
  turnOffCompareMode: ({
    ledgerId,
    workflowId,
  }: {
    ledgerId: number
    workflowId: number
  }) => Promise<void>
} => {
  const uiStore = useWorfklowUI()

  const { compareLedgerId: storedComparedLegerId } = storeToRefs(uiStore)

  function updateUI(): void {
    if (redirect) {
      uiStore.toggleReloadingMode()

      window.Turbolinks.visit(window.location.href)
    }
  }

  async function turnOnCompareMode({
    compareLedgerId,
    ledgerId,
    workflowId,
  }: {
    compareLedgerId?: number
    ledgerId: number
    workflowId: number
  }): Promise<void> {
    const effectiveCompareLedgerId =
      compareLedgerId ?? storedComparedLegerId.value

    if (effectiveCompareLedgerId) {
      setQueryParam('compare_ledger_id', effectiveCompareLedgerId.toString())
    }

    try {
      await api.persistWFReviewCompareLedgerId({
        compareLedgerId: effectiveCompareLedgerId,
        workflowId,
        ledgerId,
      })

      updateUI()
    } catch (e) {
      SfLog.warn('Error turning on compare mode', {
        extra: {
          error: e,
        },
      })
    }
  }

  async function turnOffCompareMode({
    ledgerId,
    workflowId,
  }: {
    ledgerId: number
    workflowId: number
  }): Promise<void> {
    setQueryParam('compare_ledger_id', '')

    try {
      await api.deleteWFReviewCompareLedgerId({
        workflowId,
        ledgerId,
      })

      updateUI()
    } catch (e) {
      SfLog.warn('Error turning off compare mode', {
        extra: {
          error: e,
        },
      })
    }
  }

  return {
    turnOnCompareMode,
    turnOffCompareMode,
  }
}
